import { v4 } from 'uuid';
import Style from '@/components/four-step-component/four-step-block/style';
import { FontStyle } from '@/components/style';

export default class FourStepBlock extends HTMLElement {
  constructor() {
    super();
    this.uuid = v4();
    this.imageContainerId = `${this.constructor.name}_${this.uuid}_image`;

    this.attachShadow({ mode: 'open' });

    this.shadowRoot.innerHTML = `
          ${FontStyle}
          ${Style}

          <div
          class="four-step-block-image"
          style="background-image: url('${this.imgSrc}')"
          ></div>
          <div
            style="background-color: ${this.backgroundColor};"
            class="four-step-block-text-container"
           >
            <div class="body-font-4">${this.getAttribute('eyebrow')}</div>
            <div class="title-font-9">${this.getAttribute('title')}</div>
            <div class="body-font-1">
            ${this.getAttribute('description')}
            </div>
            <a
                href="${this.getAttribute('link')}"
                class="cta-text learn-more-container"
            >
                ${this.linkText[0]}
                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="2" viewBox="0 0 27 2" fill="none">
                    <path d="M0 1H27" stroke="black" stroke-width="0.75"/>
                </svg>
                ${this.linkText[1]}
            </a>
          </div>
        `;
  }

  get linkText() {
    const value = this.getAttribute('linkText');
    const currentLinkText = value
      ? value.split(' ', 2)
      : 'learn more'.split(' ', 2);
    return currentLinkText;
  }

  set linkText(value) {
    this.setAttribute('linkText', value);
  }

  get backgroundColor() {
    return this.getAttribute('backgroundColor');
  }

  set backgroundColor(value) {
    this.setAttribute('backgroundColor', value);
  }

  get imgSrc() {
    return this.getAttribute('imgSrc');
  }

  set imgSrc(value) {
    this.setAttribute('imgSrc', value);
  }
}
